import { createSelector } from '@reduxjs/toolkit';
import { uiMarketsAdapter } from '~SpectateStore/slices/uiMarketsSlice';
import { selectMarketName } from '~SpectateStore/selectors/marketsSelectors';

export const {
    selectById: selectUiMarketById,
    selectAll: selectAllUiMarkets,
} = uiMarketsAdapter.getSelectors(state => state.uiMarkets);

export const selectMarketIdsforUiMarket = (state, id) => selectUiMarketById(state, id)?.market_ids;
export const selectLinesforUiMarket = (state, id) => selectUiMarketById(state, id)?.lines;
export const selectUiMarketName = (state, id) => selectUiMarketById(state, id)?.name;
export const selectUiMarketSlug = (state, id) => selectUiMarketById(state, id)?.slug;
export const selectColumnsForUiMarket = (state, id) => selectUiMarketById(state, id)?.columns;

export const selectUiMarketHeaders = createSelector(
    [
        state => state,
        selectMarketIdsforUiMarket,
    ],
    (state, uiMarketIds) => {
        if (uiMarketIds) {
            return uiMarketIds.map((id) => selectMarketName(state, id));
        }

        return [];
    }
);

export const selectGoalscorerMarketHeaders = createSelector(
    selectColumnsForUiMarket,
    columns => (columns ?? []).map(({ label }) => label),
);
